import { Ref, computed, provide } from "vue";
import { viewportService } from "@services/viewport.service";
import { CurrentUser } from "@utils/user";

export const useUserProfile = (user: Ref<UsersV2.User>) => {
  const profileOwner = computed(() => CurrentUser.id === user.value.id);

  const targetType = computed(() => {
    if (user.value.type === "advisor") return "UserProfileAdvisor";
    return "UserProfileBasic";
  });

  provide("trackingUserType", targetType.value);

  provide("userId", user.value.id);

  provide("userSlug", user.value.slug);

  const showPolicies = computed(() => ({
    contact: user.value.policies.contact_data,
    conversations: user.value.policies.conversations && !profileOwner.value,
    description: !!user.value.description || profileOwner.value,
    edit: profileOwner.value,
    interests: profileOwner.value,
    portfolios: user.value.portfolios_count > 0 || profileOwner.value,
    products: (user.value.policies.product_watchlist && user.value.products_count > 0) || profileOwner.value,
    profile: user.value.policies.profile || profileOwner.value,
    articles: true,
    resumeItems: (user.value.policies.resume_items && user.value.resume_items.length > 0) || profileOwner.value,
    qualifications: (user.value.policies.qualifications && user.value.qualifications.length > 0) || profileOwner.value,
    advisoryServies: user.value.type === "advisor" && (user.value.advisory_services.length > 0 || profileOwner.value),
    imprint:
      user.value.type === "advisor" &&
      (profileOwner.value || !!user.value.imprint || user.value.advisory_services.length > 0),
  }));

  const vanguardBadge = computed(() => user.value.badges.find((badge) => badge.title === "Vanguard"));

  const desktopViewport = computed(() => viewportService.check(["lg", "xl", "xxl"]));

  return {
    profileOwner,
    targetType,
    showPolicies,
    vanguardBadge,
    desktopViewport,
  };
};

export default useUserProfile;
